<template>
  <section class="edit-container">
    <h2>Edit Credit Transfer Request</h2>
    <div class="abs-top-right">
      <v-button @click="$emit('cancel')">Cancel</v-button>
      <v-button
        type="primary"
        @click="handlerSave">Save</v-button>
    </div>
    <div class="form-container">
      <div class="form-item">
        <span class="mg-b-10">Transfer Type</span>
        <v-radio-group
          v-model="formData.cashout_type"
          block
          :list="cashout_list" />
      </div>
      <div class="form-item">
        <span>Transfer Amount</span>
        <v-input v-model="formData.money" />
      </div>
      <div class="form-item">
        <span>Bank Account Holder</span>
        <v-input v-model="formData.card_holder" />
      </div>
      <div class="form-item">
        <span>Bank</span>
        <v-select
          v-model="formData.bank_code"
          valueKey="bank_code"
          is-string
          labelKey="bank_name"
          :list="bankCashoutList" />
      </div>
      <div class="form-item">
        <span>Bank Account No.</span>
        <v-input v-model="formData.card_number" />
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinBank from '@/mixins/bank'
import { changeTicketCategory, editTicketCredit } from '@/api/ticket'
import { mapState } from 'vuex'
export default {
  name: 'EditCreditTransfer',
  mixins: [MixinOptions,MixinBank],
  props: {
    ticketId: [Number, String],
    changeCategoryType: {
      type: [String, Number],
      default: ''
    },
    customerId: Number,
    form: {
      type: Object,
      default: () => ({})
    },
    referrerId: {
      type: Number,
      default: 0
    },
    isFina: {
      type: Boolean,
      default:false
    }
  },
  data() {
    return {
      formData: {
        money: '',
        card_holder: '',
        bank_code: '',
        card_number: '',
        cashout_type:''
      },
    }
  },
  computed:{
    ...mapState('common', ['bankList']),
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
        let {type} = val
        this.formData.cashout_type = type
      }
    }
  },
  methods: {
    handlerSave() {
      if(this.changeCategoryType === '') {
        this.network().editTicketCredit()
      } else {
        this.network().changeTicketCategory()
      }
    },
    network() {
      return {
        changeTicketCategory: async () => {
          let params = {}
          if(this.isFina){
            params.referrer_id = this.referrerId
          }
          const { data } = await changeTicketCategory({
            ticket_id: this.ticketId,
            type: 4,
            customer_id: this.customerId,
            ...this.formData,
            ...params,
            merchant_platform:this.isFina?2:1
          })
          this.$emit('save')
        },
        editTicketCredit: async () => {
          let params = {}
          if(this.isFina){
            params.referrer_id = this.referrerId
          }
          const { data } = await editTicketCredit({
            ticket_id: this.ticketId,
            customer_id: this.customerId,
            ...params,
            ...this.formData
          })
          this.$emit('save')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-container {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 20px;
        right: 15px;
    }
    .form-container {
        width: 370px;
    }
}
</style>
